export const env = {
  APP_ENV: import.meta.env.VITE_APP_ENV || "development",
  EMAIL_DOMAIN: import.meta.env.VITE_EMAIL_DOMAIN || "aaffice.com",

  APP_VERSION: import.meta.env.VITE_APP_VERSION || "1.0.0",

  API_BASE_URL:
    import.meta.env.VITE_API_BASE_URL || "http://localhost:3000/api",

  SOCKET_URL: import.meta.env.VITE_SOCKET_URL || "http://localhost:3000",

  APP_NAME: import.meta.env.VITE_APP_NAME || "AMail",

  ENABLE_DEBUG: import.meta.env.VITE_ENABLE_DEBUG === "true",

  isDevelopment: import.meta.env.VITE_APP_ENV === "development",
  isStaging: import.meta.env.VITE_APP_ENV === "staging",
  isProduction: import.meta.env.VITE_APP_ENV === "production",
  ADMIN_URL: import.meta.env.VITE_ADMIN_URL || "https://admin.aaffice.com",

  CHAT_URL: import.meta.env.VITE_CHAT_URL || "https://connect.aaffice.com",
  VITE_DRIVE_URL: import.meta.env.VITE_DRIVE_URL || "https://drive.aaffice.com",
  SUPER_ADMIN_URL: import.meta.env.VITE_SUPER_ADMIN_URL || "https://superadmin.aaffice.com",

  // Payload Encryption Configuration
  ENCRYPTION_KEY: import.meta.env.VITE_ENCRYPTION_KEY || "",
  ENABLE_PAYLOAD_ENCRYPTION: import.meta.env.VITE_ENABLE_PAYLOAD_ENCRYPTION === "true",

  // Cookie Security
  COOKIE_SECRET: import.meta.env.VITE_COOKIE_SECRET || "default-secret-key",
} as const;

export type Env = typeof env;

if (!env.COOKIE_SECRET && env.APP_ENV !== "development") {
  throw new Error("VITE_COOKIE_SECRET is required in production/staging environments");
}

if (env.ENABLE_DEBUG) {
  console.log("🚀 Environment Configuration:", {
    environment: env.APP_ENV,
    version: env.APP_VERSION,
    apiUrl: env.API_BASE_URL,
    socketUrl: env.SOCKET_URL,
  });
}
